import React from 'react';
import { CBadge } from '@coreui/react';
import { WalletPlatform } from '../pages/wallets/types';

const PlatformBadge = ({ platform }: { platform: WalletPlatform }) => (
  <CBadge color={platform === WalletPlatform.Wintrado ? 'info' : 'warning'}>{platform}</CBadge>
);

export default PlatformBadge;
